import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderLine } from '../../../order/models/order-line';
import { AreaItem } from '../../models/area-item';
import { Partner } from '../../../partner/models/partner';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { OrderStateService } from '../../../order/services/order-state.service';



@Component({
  selector: 'app-booking-product-configuration-form',
  templateUrl: './booking-product-configuration-form.component.html',
  styleUrls: ['./booking-product-configuration-form.component.css']
})
export class BookingProductConfigurationFormComponent implements OnInit {
  @Input() orderLine: OrderLine;
  @Input() orderIndex: number;
  @Input() isPartnerRequired: boolean;
  @Input() isBirthdayRequired: boolean;
  @Input() startPersonsNumbering: number;
  @Input() isPhoneRequired = false;
  @Input() isAddressRequired = false;
  @Input() isEmailRequired = false;

  private _areaItems: AreaItem[];
  quantity: number;
  partners: Partner[];
  easyMode: boolean;
  private _partnerValidByIndex: boolean[];
  newStartPersonsNumbering = 0;

  @Output() isShowForwardButtonEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() startPersonNumberingEvent: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    private partnerStateService: PartnerStateService,
    private shopSettingsService: ShopSettingsService,
    private orderStateService: OrderStateService,
  ) { }

  ngOnInit() {
    if (!this.orderLine) {
      return;
    }
    this.easyMode = true;
    if (!this.orderLine.partners) {
      this.orderLine.partners = new Array<Partner>();
    }
    this.partners = this.orderLine.partners;
    this.quantity = this.orderLine && this.orderLine.quantity ? this.orderLine.quantity : 0;
    if (this.partners.length > this.quantity) {
      this.partners.length = this.quantity;
    }
    this._partnerValidByIndex = new Array<boolean>(this.quantity);
    if (this.partners.length < this.quantity) {
      const newQuantity = this.quantity - this.partners.length;
      for (let i = 0; i < newQuantity; i++) {
        this.partners.push(this.getChildPartner());
      }
    }
    if (this.partners && this.partners.length > 0) {
      this.startPersonNumberingEvent.emit(this.startPersonsNumbering + this.partners.length);
      this.newStartPersonsNumbering = this.startPersonsNumbering + 1;
    }
  }

  partnerFormState(partnerIndex: number, valid: boolean) {
    if (!this._partnerValidByIndex || this._partnerValidByIndex.length < partnerIndex) {
      return;
    }
    this._partnerValidByIndex[partnerIndex] = valid;
    this.updateStateShowForwardButton();
    if (this.isFormsValid) {
      this.orderStateService.orderSaveToLocalStorage();
    }
  }

  get isFormsValid(): boolean {
    if (!this._partnerValidByIndex || this._partnerValidByIndex.length === 0) {
      return false;
    }
    return !this._partnerValidByIndex.some(value => value === false);
  }

  updateStateShowForwardButton(): void {
    this.isShowForwardButtonEvent.emit(this.isFormsValid);
  }

  get productName(): string {
    if (!this.orderLine || !this.orderLine.name) {
      return;
    }
    return this.orderLine.name;
  }

  get showBirthdayForm(): boolean {
    return !this.isBirthdayRequired;
  }

  get showPhone(): boolean {
    return this.isPhoneRequired;
  }

  get showAddress(): boolean {
    return this.isAddressRequired;
  }

  get showEmail(): boolean {
    return this.isEmailRequired;
  }

  get showPartnerNames(): boolean {
    return this.isPartnerRequired || this.isBirthdayRequired;
  }

  private getChildPartner(): Partner {
    const partner = new Partner();
    if (!this.isVUMode) {
      const defaultPartner = this.getDefaultPartner();
      partner.firstName = defaultPartner?.firstName || '';
      partner.lastName = defaultPartner?.lastName || '';
      partner.email = defaultPartner?.email || '';
      partner.phone = defaultPartner?.phone || '';
    }
    return partner;
  }

  private getDefaultPartner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }

  private get isVUMode(): boolean {
    return this.shopSettingsService.isVUMode;
  }
}
